
export class DestinacaoReservaModel {

    constructor(
        public cdCentrus?: string,
        public cdCentrusTit?: string,
        public dsParcela?: string,
        public dsPagamento?: string,
        public vlPagamento?: number,
        public dsPagamento2?: string,
        public vlPagamento2?: number,
        public dsAdvogado?: string,
        public vlAdvogado?: number,
        public dsImposto?: string,
        public vlDiferenca?: number,
        public dsDiferenca?: string,
        public vlImposto?: number,
        public dsLiquido?: string,
        public vlLiquido?: number,
        public dsMensagem?: string,
        public dsBanco?: string,
        public dsAgencia?: string,
        public dsConta?: string,
        public dsPagamento3?: string,
        public vlPagamento3?: number,
        public dsPagamento4?: string,
        public vlPagamento4?: number,
        public dsPagamento5?: string,
        public vlPagamento5?: number,
        public vlPagamento6?: number,
        public dsPagamento6?: string,
        public vlPagamento7?: number,
        public dsPagamento7?: string
        ) {
        }
    }




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/destinacao-reserva.model.ts